import React from "react";
import {
  FaCalendarAlt,
  FaCheckCircle,
  FaClock,
  FaHeart,
  FaLayerGroup,
  FaSyncAlt,
  FaUserCheck,
} from "react-icons/fa";

export default function CalendarEventsHero({ stats, loading, onRefresh }) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-sky-500/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-44 w-44 rounded-full bg-lime-500/30 blur-3xl" />

      <div className="relative">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-sky-200">
              <FaCalendarAlt className="text-[0.7rem]" />
              Événements du club
            </p>

            <h2 className="mt-3 text-2xl font-bold tracking-tight sm:text-3xl">
              Calendrier des événements
            </h2>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-200">
              Retrouvez les compétitions, stages, animations, cours communs et
              passages de grade. Filtrez les événements, gérez vos favoris et
              inscrivez vos adhérents.
            </p>

            <div className="mt-4 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold text-slate-200 backdrop-blur">
                <FaClock className="text-sky-200" />
                À venir / passés
              </span>

              <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold text-slate-200 backdrop-blur">
                <FaUserCheck className="text-lime-200" />
                Inscriptions
              </span>

              <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold text-slate-200 backdrop-blur">
                <FaHeart className="text-rose-200" />
                Favoris
              </span>
            </div>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-2xl bg-white px-4 text-sm font-bold text-slate-950 shadow-lg transition hover:bg-white/90 disabled:cursor-not-allowed disabled:opacity-70"
          >
            <FaSyncAlt className={loading ? "animate-spin" : ""} />
            Actualiser
          </button>
        </div>

        <div className="mt-5 grid grid-cols-3 gap-2">
          <HeroStat
            icon={FaCalendarAlt}
            label="Total"
            value={loading ? "…" : stats?.total || 0}
          />

          <HeroStat
            icon={FaClock}
            label="À venir"
            value={loading ? "…" : stats?.upcoming || 0}
          />

          <HeroStat
            icon={FaHeart}
            label="Favoris"
            value={loading ? "…" : stats?.favorites || 0}
          />
        </div>

        <div className="mt-3 flex flex-wrap gap-2 text-xs font-semibold text-slate-200">
          <span className="rounded-full border border-white/10 bg-white/10 px-3 py-1.5 backdrop-blur">
            {loading ? "…" : stats?.past || 0} passé
            {(stats?.past || 0) > 1 ? "s" : ""}
          </span>

          <span className="rounded-full border border-white/10 bg-white/10 px-3 py-1.5 backdrop-blur">
            {loading ? "…" : stats?.types || 0} type
            {(stats?.types || 0) > 1 ? "s" : ""}
          </span>

          <span className="rounded-full border border-white/10 bg-white/10 px-3 py-1.5 backdrop-blur">
            Calendrier interactif
          </span>
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-3 text-center backdrop-blur">
      <div className="mx-auto flex h-9 w-9 items-center justify-center rounded-xl bg-white/15">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-lg font-bold leading-none">{value}</p>
      <p className="mt-1 text-[11px] font-medium text-slate-300">{label}</p>
    </div>
  );
}